import {ISignal} from "strongly-typed-events/dist/definitions/subscribables";
import {SignalDispatcher} from "strongly-typed-events/dist/signals";

export class CalendarDaySlot {

    private selectedChanged:SignalDispatcher = new SignalDispatcher();

    private selected:boolean;
    private clicked:boolean;
    private available:boolean;
    private time:CalendarTime;

    constructor(time: CalendarTime) {
        this.available = true;
        this.time = time;
        this.selected = false;
        this.clicked = false;
    }

    public ResetSelection(){
        this.selected = false;
        this.clicked = false;
        this.selectedChanged.dispatch();
    }

    public Click(){
        this.clicked = true;
    }

    public Clicked():boolean{
        return this.clicked;
    }

    public Select(){
        this.selected = true;
        this.clicked = false;
        this.selectedChanged.dispatch();
    }

    public Taken(){
        this.available = false;
    }

    public Free(){
        this.available = true;
    }

    public Available():boolean{
        return this.available;
    }

    public Selected():boolean{
        return this.selected;
    }

    public Time():CalendarTime{
        return this.time;
    }

    public SelectedChanged():ISignal{
        return this.selectedChanged;
    }

    public ToString():string{
        return this.time == CalendarTime.AM ? 'AM' : 'PM';
    }
}

export enum CalendarTime {
    AM,
    PM
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/entities/CalendarDaySlot.ts